import axios from '@/components/api/axios';

async function getList() {
  const res = await axios.axiosGet('/api/fanClub/summitMember/getThumbnailList', null);
  return res;
}

async function getDetail(id) {
  let data = {
    id: id
  }
  const res = await axios.axiosGet('/api/fanClub/summitMember/getDetail', data);
  return res;
}

export default {
  getList,
  getDetail
}



// WEBPACK FOOTER //
// ./src/components/api/summit.js